"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var HuddleView = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_HuddleView_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM3 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM1.6 9A1.6 1.6 0 0 1 0 7.4C0 6.075 1.6 5 4 5s4 1.075 4 2.4A1.6 1.6 0 0 1 6.4 9H1.6Zm.027-2.447C2.132 6.24 2.937 6 4 6c1.063 0 1.868.24 2.373.553.503.312.627.631.627.847a.6.6 0 0 1-.6.6H1.6a.6.6 0 0 1-.6-.6c0-.216.124-.535.627-.847ZM14 9a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm-2 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM9.6 16A1.6 1.6 0 0 1 8 14.4c0-1.325 1.6-2.4 4-2.4s4 1.075 4 2.4a1.6 1.6 0 0 1-1.6 1.6H9.6Zm.027-2.447C10.132 13.24 10.937 13 12 13c1.063 0 1.868.24 2.373.553.503.312.627.631.627.847a.6.6 0 0 1-.6.6H9.6a.6.6 0 0 1-.6-.6c0-.216.124-.535.627-.847Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3H6.83c.11-.313.17-.65.17-1h5a2 2 0 0 1 2 2v2.764a2.998 2.998 0 0 0-1-.593V4a1 1 0 0 0-1-1ZM2 12v-2h1v2a1 1 0 0 0 1 1h3.399a2.685 2.685 0 0 0-.369 1H4a2 2 0 0 1-2-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_HuddleView_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = HuddleView;
exports["default"] = _default;